import {
  collection,
  getDocs,
  limit as limitFn,
  orderBy,
  query,
  serverTimestamp,
  where,
} from 'firebase/firestore';
import { addDataToTable, deleteDocById } from '../utils';
import { db } from '../firebase';

export const addRequest = async (request, setLoading) =>
  // Stamp a creation time so the notifications feed can sort pending items by
  // date alongside archived history (which carries archivedAt).
  addDataToTable({ tableName: 'requests', data: { createdAt: serverTimestamp(), ...request }, setLoading });

export const rejectRequest = async (id, setLoading) =>
  deleteDocById({ tableName: 'requests', id, setLoading });

// Archive a delivered notification into the per-user history before it's
// removed from the live `requests` inbox. Stores only display fields so the
// history is independent of the `requests` queue (which the server clears).
export const archiveNotification = async (userId, request) =>
  addDataToTable({
    tableName: 'notificationHistory',
    data: {
      userId,
      type: request.type ?? 'general',
      title: request.title ?? request.placeName ?? '',
      body: request.body ?? '',
      startDate: request.startDate ?? '',
      matchDate: request.matchDate ?? request.startDate ?? '',
      from: request.from ?? '',
      actorId: request.actorId ?? '',
      action: request.action ?? '',
      placeName: request.placeName ?? '',
      url: request.url ?? '',
      photoURL: request.photoURL ?? '',
      archivedAt: serverTimestamp(),
    },
  });

// Trae solo las N notificaciones más recientes del usuario, ordenadas
// server-side por archivedAt desc. Antes traía TODO el historial sin
// límite y ordenaba en el cliente — el drawer de notificaciones se
// ponía muy lento en cuentas viejas. Requiere el índice compuesto
// (userId asc, archivedAt desc) declarado en firestore.indexes.json.
export const fetchNotificationHistory = async (userId, max = 50) => {
  const q = query(
    collection(db, 'notificationHistory'),
    where('userId', '==', userId),
    orderBy('archivedAt', 'desc'),
    limitFn(max),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ ...d.data(), id: d.id }));
};
